import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, Mail, Phone, MapPin, Facebook, Youtube, Instagram, Send } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-dark-900 to-secondary-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
            <div className="h-16 flex items-center overflow-hidden">
              <img 
                src="/logo3.png" 
                alt="Omkar Analytics Logo" 
                width="96"
                height="64"
                className="h-16 w-auto object-contain transform scale-150"
              />
            </div>
              <div>
                <h1 className="text-xl font-bold">Omkar Research</h1>
                <p className="text-sm text-gray-400">Analyst</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Empowering smart investment decisions through accurate market analysis and timely insights. Your trusted partner in financial growth.
            </p>
            <div className="flex space-x-6">
              <a href="https://www.facebook.com/omkarresearchanalyst/" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-all transform hover:scale-110 bg-gray-800 hover:bg-blue-600 p-3 rounded-full shadow-lg">
                <Facebook className="w-6 h-6" />
              </a>
              <a href="https://www.youtube.com/@omkarresearchanalyst" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-all transform hover:scale-110 bg-gray-800 hover:bg-red-600 p-3 rounded-full shadow-lg">
                <Youtube className="w-6 h-6" />
              </a>
              <a href="https://t.me/omkarresearchanalyst123" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-all transform hover:scale-110 bg-gray-800 hover:bg-blue-500 p-3 rounded-full shadow-lg">
                <Send className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/omkar_research_analyst?igsh=MXR2bWkxY29qcGdwcw==" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-all transform hover:scale-110 bg-gray-800 hover:bg-pink-600 p-3 rounded-full shadow-lg">
                <Instagram className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/aboutus" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/research-dashboard" className="text-gray-400 hover:text-white transition-colors"></Link></li>
              <li><Link to="/contactus" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/careers" className="text-gray-400 hover:text-white transition-colors">Careers</Link></li>
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors">Blog</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white transition-colors">FAQ</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/equity-research" className="text-gray-400 hover:text-white transition-colors">Equity Research</Link></li>
              <li><Link to="/commodity-research" className="text-gray-400 hover:text-white transition-colors">Commodity Research</Link></li>
              <li><Link to="/financial-adviser" className="text-gray-400 hover:text-white transition-colors">Financial Adviser</Link></li>
              {/* <li><Link to="/portfolio-management" className="text-gray-400 hover:text-white transition-colors">Portfolio Management</Link></li> */}
              {/* <li><Link to="/risk-management" className="text-gray-400 hover:text-white transition-colors">Risk Management</Link></li> */}
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">All Services</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary-600 mt-0.5" />
                <div>
                  <p className="text-gray-400 text-sm">5/2 Chitraami Apartment</p>
                  <p className="text-gray-400 text-sm">Opp Old RBI, Ashram Road</p>
                  <p className="text-gray-400 text-sm">Ahmedabad, Gujarat 380009</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-primary-600" />
                <a href="tel:+919898001671" className="text-gray-400 hover:text-white transition-colors">+919898001671</a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-primary-600" />
                <a href="mailto:info@omkarresearchanalyst.in" className="text-gray-400 hover:text-white transition-colors">info@omkarresearchanalyst.in</a>
              </div>
            </div>
          </div>
        </div>

        {/* SEBI Compliance & Services Card */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="grid md:grid-cols-4 gap-8">
            {/* SEBI Registration Details */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-primary-600">SEBI Registration</h3>
              <div className="text-sm text-gray-300 space-y-1">
                <p><span className="font-semibold">Registered Name:</span> Omkar Research Analyst</p>
                <p><span className="font-semibold">Type:</span> Individual</p>
                <p><span className="font-semibold">Registration No.:</span> INH000021359</p>
                <p><span className="font-semibold">Validity:</span> June 25, 2028</p>
                <p className="text-gray-400 mt-2">Securities & Exchange Board of India</p>
                <p className="text-gray-400">Panchavati Society, Gulbai Tekra</p>
                <p className="text-gray-400">Ahmedabad, Gujarat 380006</p>
              </div>
            </div>
            
            {/* Client Services */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Client Services</h4>
              <ul className="space-y-2">
               
                <li><a href="/client-consent" className="text-gray-400 hover:text-white transition-colors text-sm">Client Consent</a></li>
                <li><a href="/disclaimer" className="text-gray-400 hover:text-white transition-colors text-sm">Disclaimer</a></li>
                <li><a href="/disclosure" className="text-gray-400 hover:text-white transition-colors text-sm">Disclosure</a></li>
                <li><a href="/service-disclosure" className="text-gray-400 hover:text-white transition-colors text-sm">Service Disclosure</a></li>
                <li><a href="/terms-and-conditions" className="text-gray-400 hover:text-white transition-colors text-sm">Terms and Conditions</a></li>
                <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors text-sm">Privacy Policy</Link></li>
                <li><Link to="/refund_policy" className="text-gray-400 hover:text-white transition-colors text-sm">Cancellation & Refund Policy</Link></li>
              </ul>
            </div>
            
            {/* Support */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Support</h4>
              <ul className="space-y-2">
                <li><a href="/complaints" className="text-gray-400 hover:text-white transition-colors text-sm">Complaints</a></li>
                <li><a href="/complaints-redressal" className="text-gray-400 hover:text-white transition-colors text-sm">Complaints Redressal</a></li>
                <li><a href="/grievance-redressal" className="text-gray-400 hover:text-white transition-colors text-sm">Grievance Redressal</a></li>
              </ul>
            </div>
            
            {/* Company */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Company</h4>
              <ul className="space-y-2">
                <li><a href="/careers" className="text-gray-400 hover:text-white transition-colors text-sm">Careers</a></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Disclaimers */}
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-primary-600">Important Disclaimers</h3>
          <div className="text-xs text-gray-400 space-y-2">
            <p>Warning - Investment in securities market are subject to market risks. Read all the related documents carefully before investing.</p>
            <p>Disclaimer - Registration granted by SEBI, enlistment as RA with Exchange and certification from NISM in no way guarantee performance of the intermediary or provide any assurance of returns to investors.</p>
            <p className="mt-2">This site is protected by reCAPTCHA and the Google <a className="underline hover:text-gray-300" href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a className="underline hover:text-gray-300" href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            {currentYear} Omkar Research Analyst. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2 md:mt-0">
            Built with for smart investing
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;